// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"0b83fd67","416":"241234ae","587":"190229b6","940":"a7688fb2"}[chunkId] + ".chunk.js";
};